import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import OrderIds from './Orderdetails'

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    orderIds: OrderIds,
});

export default reducers;